Ext.ns('mx.app.widget');

mx.app.widget.EventManager = Ext.extend(Ext.Component, {
    store: null,
    started: false,
    confirmedEvents: [],
    deferedEvents: [],
    timings: {
        pull: 1000,
        timeout: 30000,
        afterError: 10000,
    },
    registeredEvents: [],
    initComponent: function() {
        this.registeredEvents = MXAT.events || [];
        this.registeredEvents.forEach(function(event) {
            this.addEvents(event);
        }, this);
        this.store = Ext.StoreMgr.lookup('events');
    },

    onDestroy: function() {
        this.stop();
    },

    addListener: function() {
        mx.app.widget.EventManager.superclass.addListener.apply(this, arguments);
        this.deferedEvents = [];
        this.start();
    },
    removeListener: function() {
        mx.app.widget.EventManager.superclass.removeListener.apply(this, arguments);
        var listenersCount = 0;
        this.registeredEvents.forEach(function(eventName) {
            if (typeof this.events[eventName] == 'object') {
                //Ext.util.Event
                listenersCount += this.events[eventName].listeners.length;
            }
        }, this);
        if (!listenersCount) {
            this.stop();
        }
    },

    start: function() {
        if (this.store && !this.started) {
            this.started = true;
            //            this.store.on('load', this.onHandle, this);
            //            this.store.on('loadexception', this.onError, this);
            //            this.store.load();
            this.sendRequest();
        }
    },

    sendRequest: function(params) {
        this.request = mx.data.Ajax.request({
            url: mx.PATH + this.store.url,
            params: params || {},
            method: 'GET',
            success: function(response) {
                var o = this.store.reader.read(response);
                if (o.success) {
                    this.onHandle(o.records);
                } else {
                    this.onError(o.errors);
                }
            },
            failure: function() {},
            scope: this,
        });
    },

    onError: function(obj) {
        console.log(arguments);
    },

    onHandle: function(r) {
        r.forEach(function(record) {
            var eventName = record.get('type');
            if (eventName && eventName == 'confirmed_event') {
                var j = this.confirmedEvents.indexOf(record.getRecordId());
                if (j != -1) {
                    this.confirmedEvents.splice(j, 1);
                }
            } else if (eventName) {
                if (this.hasListener(eventName)) {
                    this.fireEvent(eventName, record);
                } else {
                    this.deferedEvents.push(record.getRecordId());
                    //                    this.confirmedEvents.push(record.getRecordId());
                }
            }
        }, this);

        var params = {};
        if (this.confirmedEvents.length) {
            params['confirmedIds'] = this.confirmedEvents;
            this.confirmedEvents.forEach(function(i) {
                var j = this.deferedEvents.indexOf(i);
                if (j != -1) {
                    this.deferedEvents.splice(j, 1);
                }
            }, this);
        }

        if (this.deferedEvents.length) {
            params['deferredIds'] = this.deferedEvents;
        }

        (function() {
            if (this.started) {
                this.sendRequest(params);
            }
        }.defer(this.timings.pull, this));
    },

    confirm: function(eventId) {
        if (this.confirmedEvents.indexOf(eventId) == -1) {
            this.confirmedEvents.push(eventId);
        }
    },

    stop: function() {
        Ext.Ajax.abort(this.request);
        this.started = false;
        //        if (this.store) {
        //            this.store.un('load');
        //        }
    },
});

mx.app.widget.EventManager.prototype.on = mx.app.widget.EventManager.prototype.addListener;
mx.app.widget.EventManager.prototype.un = mx.app.widget.EventManager.prototype.removeListener;
